import React from 'react';

type YourPrivacyChoicesIconProps = {
  size?: number;
};

/**
 * Standard IAB "Your Privacy Choices" icon: a rounded pill split into a white
 * half with a blue check (opt-in) and a blue half with a white cross (opt-out).
 * Shown next to the "Your Privacy Choices" link to signal the US state-privacy
 * opt-out mechanism.
 *
 * @see https://github.com/InteractiveAdvertisingBureau/Your-Privacy-Choices-Icon
 */
export const YourPrivacyChoicesIcon = ({
  size = 29,
}: YourPrivacyChoicesIconProps) => {
  const width = size;
  const height = Math.round((size * 14) / 29);
  const blue = '#007aff';

  return (
    <svg
      focusable="false"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 29 14"
      fill="none"
    >
      {/* Pill background (opt-in half) */}
      <path
        d="M7 0.5H22C25.5899 0.5 28.5 3.41015 28.5 7C28.5 10.5899 25.5899 13.5 22 13.5H7C3.41015 13.5 0.5 10.5899 0.5 7C0.5 3.41015 3.41015 0.5 7 0.5Z"
        fill="white"
        stroke={blue}
      />
      {/* Opt-out half */}
      <path
        d="M14.5 0.5H22C25.5899 0.5 28.5 3.41015 28.5 7C28.5 10.5899 25.5899 13.5 22 13.5H14.5V0.5Z"
        fill={blue}
      />
      {/* Check mark */}
      <path
        d="M6 7.4L8.1 9.5L12.3 5.3"
        stroke={blue}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Cross mark */}
      <path
        d="M16.8 5.1L21.6 9.9M21.6 5.1L16.8 9.9"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
